import apiClient from "./apiClient";

// invoices
export const getInvoiceReport = (
  noLimit = true, 
  invoiceDateStart = "", 
  invoiceDateEnd = "",
  dueDateStart = "",
  dueDateEnd = "",
  petOwnerId = "",
  historyEntryUserId = "",
  procedureId = ""
) => apiClient
  .get("/reports/invoice", { params: { noLimit, invoiceDateStart, invoiceDateEnd, dueDateStart, dueDateEnd, petOwnerId, historyEntryUserId, procedureId } })
  .then(res => res);

  export const getMedicalHistoryReport = (
  noLimit = true, 
  dateStart = "", 
  dateEnd = "",
  petId = "",
  petOwnerId = "",
  historyEntryUserId = "", 
  procedureId = ""
) => apiClient
  .get("/reports/medical-history", { params: { noLimit, dateStart, dateEnd, petId, petOwnerId, historyEntryUserId, procedureId } })
  .then(res => res);